import { useProjectContext } from "../hooks/useProjectContext";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { forwardRef } from "react";

import { canShowDetails } from "../utils/permissions";
import Modal from "./Modal";
import { useModal } from "../hooks/useModal";
import { useAuth } from "../features/accounts/contexts/AuthContext";
import { headerShell } from "../styles/headerShell";

function NavItem({ to, icon, text, onClick, end }) {
    const location = useLocation();
    const isActive = end ? location.pathname === to : location.pathname.startsWith(to);

    return (
        <div className={headerShell.navItem}>
            <NavLink to={to} className={headerShell.navLink} end={end} onClick={onClick}>
                <span
                    className={`${headerShell.navIcon} ${
                        isActive ? headerShell.navIconActive : headerShell.navIconTone
                    }`}
                >
                    {icon}
                </span>
                <span
                    className={`${headerShell.navText} ${
                        isActive ? headerShell.navTextActive : headerShell.navTextTone
                    }`}
                >
                    {text}
                </span>
            </NavLink>
        </div>
    );
}

function HeaderNav({ projectBase, hasProject, user }) {
    const canShowProjectSettings = user && canShowDetails(user);
    const navigate = useNavigate();
    const { isOpen, openModal, closeModal } = useModal();

    const handleListClick = (e) => {
        if (hasProject) {
            e.preventDefault();
            openModal();
        }
    };

    const handleConfirm = () => {
        closeModal();
        navigate("/dashboard");
    };

    return (
        <>
            <nav className={headerShell.nav}>
                {hasProject && (
                    <div className={headerShell.projectNav}>
                        <NavItem to={`${projectBase}/map`} icon="map" text="地図" />
                        <NavItem to={`${projectBase}/ai`} icon="smart_toy" text="AI会話" />
                        <NavItem to={`${projectBase}/gallery`} icon="collections" text="ギャラリー" />
                        {canShowProjectSettings && (
                            <NavItem to={`${projectBase}/detail`} icon="settings" text="設定" />
                        )}
                    </div>
                )}

                <div className={headerShell.generalNav}>
                    <NavItem to="/dashboard" icon="list" text="一覧" end onClick={handleListClick} />
                    <NavItem to={`${projectBase}/account`} icon="account_box" text="アカウント" />
                </div>
            </nav>

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title="プロジェクト一覧に戻りますか？"
                size="small"
                actions={[
                    { label: "キャンセル", variant: "secondary" },
                    { label: "一覧に戻る", variant: "primary", onClick: handleConfirm }
                ]}
            />
        </>
    );
}

const Header = forwardRef(function Header(props, ref) {
    const { projectId } = useProjectContext();
    const projectBase = projectId ? `/dashboard/${projectId}` : "/dashboard";
    const { user } = useAuth();

    const hasProject = !!projectId;

    return (
        <header className={headerShell.root} ref={ref}>
            <div className={headerShell.logoContainer}>
                <img
                    src="/logo192.png"
                    alt=""
                    className={headerShell.logoIcon}
                    width={24}
                    height={24}
                    aria-hidden="true"
                />
                <span className={headerShell.logoText}>TERRALOGUE</span>
            </div>
            <div className={headerShell.navContainer}>
                <HeaderNav projectBase={projectBase} hasProject={hasProject} user={user} />
            </div>
        </header>
    );
});

export default Header;
